export default class ErpShipmentEntity {
    static getEntityData(elem: any) {
        return {
            id: elem.querySelector("#erp_shipment_id") ? (elem.querySelector("#erp_shipment_id") as HTMLInputElement).value : null,
            shipment_company_id: (elem.querySelector("#erp_shipment_shipment_company option:checked") as HTMLInputElement).value,
        }
    }
}